import { theme } from "../../../../theme";
import * as React from "react";
import styled, { keyframes } from "styled-components";

const shake = keyframes`
  {
    8%, 41% {
      transform: translateX(-20px);
    }
    25%, 58% {
      transform: translateX(20px);
    }
    75% {
      transform: translateX(-10px);
    }
    92% {
      transform: translateX(10px);
    }
    0%, 100% {
      transform: translateX(0);
    }
  }
`;

const Container = styled.div`
  margin: 24px 0 24px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${(props: IProps) => (props.invalid ? `animation: ${shake} .5s linear;` : "")}
`;

const Entry = styled.input`
  width: 50px;
  padding: 5px;
  margin: 0 10px;
  border: solid 1px ${theme.color.inputBorderColor};
  background-color: #ffffff;
  font-size: ${theme.fontSize.header};
  font-weight: 700;
  color: ${theme.color.ruubyBlack};
  text-align: center;

  :disabled {
    color: ${theme.color.ruubyGreyLight};
  }
`;

interface IProps {
  invalid?: boolean;
  onComplete(code: string): void;
}

interface IState {
  position0: string;
  position1: string;
  position2: string;
  position3: string;
}

// tslint:disable:no-magic-numbers
export class OtpEntry extends React.PureComponent<IProps, IState> {
  private readonly entries: HTMLInputElement[] = [];
  public state: IState = {
    position0: "",
    position1: "",
    position2: "",
    position3: "",
  };

  public componentDidMount(): void {
    this.entries[0].focus();
  }

  /**
   * Reset the fields
   */
  public reset = (): void => {
    this.setState({
      position0: "",
      position1: "",
      position2: "",
      position3: "",
    });
    this.entries.forEach((e) => (e.disabled = false));
    this.entries[0].focus();
  };

  /**
   * Update code in state and focus to next field or submit
   * @param codePart The single digit part of the code
   * @param index The index part of the code to update
   */
  private handleUpdateNumber = (codePart: string, index: number): void => {
    const key = `position${index.toString()}`;

    this.setState({ ...this.state, [key]: codePart }, () => {
      if (codePart.length > 0) {
        if (index < 3) {
          this.entries[index + 1].focus();
        } else {
          this.entries[3].blur();
          this.entries.forEach((e) => (e.disabled = true));
          this.props.onComplete(
            `${this.state.position0}${this.state.position1}${this.state.position2}${this.state.position3}`,
          );
        }
      }
    });
  };

  public render(): JSX.Element {
    return (
      <Container {...this.props}>
        <Entry
          innerRef={(ref: HTMLInputElement) => (this.entries[0] = ref)}
          value={this.state.position0}
          onChange={(e) => this.handleUpdateNumber(e.currentTarget.value, 0)}
          maxLength={1}
          autoComplete="new-password"
        />
        <Entry
          innerRef={(ref: HTMLInputElement) => (this.entries[1] = ref)}
          value={this.state.position1}
          onChange={(e) => this.handleUpdateNumber(e.currentTarget.value, 1)}
          maxLength={1}
          autoComplete="new-password"
        />
        <Entry
          innerRef={(ref: HTMLInputElement) => (this.entries[2] = ref)}
          value={this.state.position2}
          onChange={(e) => this.handleUpdateNumber(e.currentTarget.value, 2)}
          maxLength={1}
          autoComplete="new-password"
        />
        <Entry
          innerRef={(ref: HTMLInputElement) => (this.entries[3] = ref)}
          value={this.state.position3}
          onChange={(e) => this.handleUpdateNumber(e.currentTarget.value, 3)}
          maxLength={1}
          autoComplete="new-password"
        />
      </Container>
    );
  }
}
